import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { isValidEntityUser } from '@/utils/user';
import { rawUserDetailsAtom, userDetailsAtom } from './queries/user';

export const userHasVideoAccessAtom = atom(async get => {
  const userDetails = await get(userDetailsAtom);

  const { hasWyscout } = userDetails.user;
  if (!hasWyscout) return false;

  const { hasWyscoutPro, hasWyscoutYouth } = userDetails.entity;

  return hasWyscoutPro || hasWyscoutYouth;
});
userHasVideoAccessAtom.debugLabel = 'userHasVideoAccessAtom';

export const userVideoAccessStatusAtom = atom(async get =>
  (await get(userHasVideoAccessAtom)) ? 'enabled' : 'disabled',
);

export const unwrappedUserVideoAccessStatusAtom = unwrap(userVideoAccessStatusAtom, prev => prev);

export const isValidEntityUserAtom = atom(async get => {
  const { data } = await get(rawUserDetailsAtom);
  return isValidEntityUser(data);
});
